module.exports = __webpack_public_path__ + "static/img/shareWhatsApp.5b303e8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/shareWhatsApp.svg
// module id = M0MT
// module chunks = 0